/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Participatedsusworkshopmentalstrength5Inputs */

const de__field_participatedsusworkshopmentalstrength5 = /** @type {(inputs: _Field_Participatedsusworkshopmentalstrength5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilgenommen an SuS-Workshop Mental Strength`)
};

/**

* @param {_Field_Participatedsusworkshopmentalstrength5Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_participatedsusworkshopmentalstrength5 = /** @type {((inputs?: _Field_Participatedsusworkshopmentalstrength5Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Participatedsusworkshopmentalstrength5Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_participatedsusworkshopmentalstrength5(inputs)
});
export { _field_participatedsusworkshopmentalstrength5 as "_field_participatedSuSWorkshopMentalStrength" }